import type { ToolFilterCondition } from '@troia-v3/types';

import type { SelectOptionGroup } from '@/shared/components/ui';

/**
 * Operadores dos filtros de webhook — mesmos das ferramentas
 * (custom-actions/components/filters/ToolFilterDefinitions.ts), avaliados
 * pelo mesmo ToolFilterEvaluator no backend.
 */
export const WEBHOOK_FILTER_OPERATORS = [
  { value: 'equals', label: 'Igual' },
  { value: 'not_equals', label: 'Diferente' },
  { value: 'contains', label: 'Contém' },
  { value: 'not_contains', label: 'Não contém' },
  { value: 'starts_with', label: 'Começa com' },
  { value: 'ends_with', label: 'Termina com' },
  { value: 'greater_than', label: 'Maior que' },
  { value: 'less_than', label: 'Menor que' },
  { value: 'is_empty', label: 'Está vazio' },
  { value: 'is_not_empty', label: 'Não está vazio' },
];

export const WEBHOOK_OPERATORS_WITHOUT_VALUE = ['is_empty', 'is_not_empty'];

/**
 * Valor sentinela do select de campo que revela o input de caminho JSON.
 * O valor persistido em `filter.field` é sempre o caminho real (`$.a.b`).
 */
export const JSON_FIELD_SENTINEL = '__json__';

/**
 * Grupos do select de campo. Webhooks miram uma conversa — sem categoria
 * Lead (decisão do spec 2026-07-02-webhook-form-tabs-json-filters).
 */
export const WEBHOOK_FIELD_GROUPS: SelectOptionGroup[] = [
  {
    label: 'JSON recebido',
    options: [{ value: JSON_FIELD_SENTINEL, label: 'Campo do JSON (personalizado)' }],
  },
  {
    label: 'Contato',
    options: [
      { value: 'contact.name', label: 'Nome' },
      { value: 'contact.phone', label: 'Telefone' },
      { value: 'contact.email', label: 'E-mail' },
      { value: 'contact.tags', label: 'Tags' },
    ],
  },
  {
    label: 'Conversa',
    options: [
      { value: 'conversation.status', label: 'Status' },
      { value: 'conversation.channelId', label: 'Canal' },
      { value: 'conversation.assigneeId', label: 'Atendente' },
    ],
  },
];

export function isJsonPathField(field: string): boolean {
  return field === '$' || field.startsWith('$.');
}

export function createEmptyWebhookFilter(): ToolFilterCondition {
  return { field: '', operator: 'equals', value: '' };
}
